import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary]', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Reset when the user navigates to another page
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] bg-[#050816] flex items-center justify-center px-4" data-testid="app-error-boundary">
        <div className="max-w-md text-center">
          <AlertTriangle className="h-10 w-10 text-[#C6A14A] mx-auto mb-4" />
          <h1 className="text-2xl font-light text-white mb-2">Something went wrong on this page</h1>
          <p className="text-[#E8E4DE]/60 mb-2">Please refresh. If it keeps happening, tell us what you clicked.</p>
          <p className="text-xs text-[#E8E4DE]/40 mb-6 break-words" data-testid="app-error-message">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <div className="flex gap-3 justify-center">
            <button onClick={() => window.location.reload()}
              className="bg-[#C6A14A] text-[#050816] px-5 py-2 rounded-lg font-medium hover:bg-[#d4b25c]" data-testid="app-error-reload-btn">
              Refresh
            </button>
            <Link to="/" onClick={() => this.setState({ error: null })}
              className="border border-white/15 text-white px-5 py-2 rounded-lg hover:bg-white/5">
              Home
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export const NotFound = () => (
  <div className="min-h-[60vh] bg-[#050816] flex items-center justify-center px-4" data-testid="not-found-page">
    <div className="text-center">
      <p className="text-[#C6A14A] tracking-[0.3em] text-sm mb-3">404</p>
      <h1 className="text-2xl font-light text-white mb-2">Page not found</h1>
      <p className="text-[#E8E4DE]/60 mb-6">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="bg-[#C6A14A] text-[#050816] px-5 py-2 rounded-lg font-medium hover:bg-[#d4b25c]" data-testid="not-found-home-link">
        Go Home
      </Link>
    </div>
  </div>
);
